// region Store

import {React, useContext} from '@api'
import {VipLocalStore} from '@modules'
import {StoresInstance} from '@stores/StoresInstance'
import {synchronizeStores} from '@stores/SynchronizeStores'
import {action, observable, reaction} from 'mobx'
import {IDisposer} from 'mobx-utils'

export const LeftSidebarContext = React.createContext<LeftSidebarStore>(undefined)
export const useLeftSidebarStore = () => useContext(LeftSidebarContext)

export class LeftSidebarStore extends VipLocalStore {
  constructor(stores: StoresInstance) {
    super(stores)
  }

  registerEffects = () => {
    const {stores: {nav, sidebar}} = this

    // this._toDispose.push(
    //   reaction(() => ({board: nav?.queryParams?.workspace}), ({board}) => {
    //     const {left, left: {selectedPathItem, path, hasLibraryView, hasFieldView}} = sidebar
    //     if (board && path.length && selectedPathItem && !hasLibraryView && !hasFieldView) {
    //       left.path.clear()
    //     }
    //   }, {delay: 50}) // Avoid immediately doing it so that the user interaction is fast
    // )
  }

  _toDispose: Array<IDisposer> = []

  dispose = () => {
    this._toDispose.forEach(f => f())
  }

  get sidebar() {
    return this.flexLayout.activeCatalogRoot?.stores?.sidebar
  }
  @action
  onClickItem = (e, libraryName) => {
    const {sidebar} = this
    _.last(sidebar.left.path).libraryId = libraryName
    _.last(sidebar.left.path).sidebarContext = 'libraries'
  }

  @action resetWidth = () => {
    const {left} = this.sidebar
    left.width = left.defaultWidth
  }

  @observable ignored
}

// endregion



// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/LeftSidebar/LeftSidebarStore.ts